<span *ngIf="activeUserId === data.value.activeUserId" class="fw-bold" data-test-id="activity-permission-you">{{
  'ACTIVITY_YOU' | translate
}}</span
><app-activities-navigate-profile
  *ngIf="activeUserId !== data.value.activeUserId"
  [user]="data.value.ownerItem"
  [dataTestId]="'activity-permission-navigate-to-profile'"
  [isDialog]="isDialog"
  (submit)="onSubmit()"
></app-activities-navigate-profile
>&nbsp;{{ 'ACTIVITY_PERMISSIONS' | translate }}
<span *ngIf="isDialog" data-test-id="activity-permission-this">{{ 'ACTIVITY_THIS' | translate }} </span>
<span data-test-id="activity-permission-file"> {{ 'ACTIVITY_FILE' | translate }} </span>
<app-activities-display-popup
  *ngIf="!isDialog"
  [rowIndex]="data.rowIndex"
  [value]="data?.value"
  [entityName]="data.value.entity_name"
  [dataTestId]="'activity-permission-file-'"
  (displayPopup)="onDisplayPopup($event)"
></app-activities-display-popup>
<span *ngFor="let user of data.value.usersWithDescriptor; index as i">
  <a>{{ 'ACTIVITY_FOR' | translate }}&nbsp;</a>
  <app-activities-navigate-profile
    [user]="user"
    [dataTestId]="'activity-permission-name-' + i"
    [isActiveUser]="activeUserId === user.user_id"
    [isDialog]="isDialog"
    (submit)="onSubmit()"
  ></app-activities-navigate-profile>
  <span [attr.data-test-id]="'activity-permission-from-' + i">&nbsp;{{ 'ACTIVITY_FROM' | translate }}</span>
  <b [attr.data-test-id]="'activity-permission-from-name-' + i">
    {{ user.permission === OWNER ? PERMISSION_READER : PERMISSION_OWNER }}</b
  >&nbsp;<span [attr.data-test-id]="'activity-permission-to-' + i">{{ 'ACTIVITY_TO' | translate }}</span>
  <b [attr.data-test-id]="'activity-permission-to-name-' + i">
    {{ (user.permission === 'owner' ? 'Owner' : 'Reader') | comma: i < data.value.usersWithDescriptor.length - 1 }}
  </b>
</span>
